export const pageSourceLinkStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '3px',
  fontSize: '11px',
  color: 'primary.main',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: 0,
  lineHeight: 1,
};

export const editIconButtonStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: 0,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  color: ({ palette }) => palette.text.secondary,
  '&:hover': {
    color: 'primary.main',
  },
};

export const fieldActionRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  marginTop: '4px',
};

/*
 * MISSING ENDPOINT: "Apply to linked entity" writes the extracted field value back to
 * the loan's linked entity (borrower income, asset, etc.). No backend endpoint exists yet
 * to perform this write. The UI affordance is built per the mockup (DEV-4106); callers
 * should NOT pass onApplyToEntity until the endpoint is available.
 */
export const applyBarStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '12px',
  color: ({ palette }) => palette.text.secondary,
  backgroundColor: ({ palette }) => palette.background.default,
  border: ({ palette }) => `1px dashed ${palette.divider}`,
  borderRadius: '8px',
  padding: '8px 12px',
  marginTop: '6px',
};

export const applyBarLinkStyles = {
  marginLeft: 'auto',
  fontWeight: 600,
  color: 'primary.main',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: 0,
  fontSize: '12px',
};
